import { render, staticRenderFns } from "./journalHomework.vue?vue&type=template&id=775654d6&lang=pug"
import script from "./journalHomework.vue?vue&type=script&lang=js"
export * from "./journalHomework.vue?vue&type=script&lang=js"
import style0 from "./journalHomework.vue?vue&type=style&index=0&id=775654d6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports